import React, { useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

/**
 * Renders nothing. Syncs Formik dirty state (values !== initialValues) to
 * DSOK customer-detail context so the global Update button can be enabled/disabled.
 * Place inside <Formik> on each section page that has an editable form.
 * On unmount resets dirty to false.
 */
const DsokCustomerDetailDirtySync = () => {
  const { values, initialValues } = useFormikContext();
  const { setDirty } = useDsokCustomerDetail();
  const prevDirtyRef = useRef(false);

  useEffect(() => {
    const dirty =
      JSON.stringify(values) !== JSON.stringify(initialValues);
    if (dirty !== prevDirtyRef.current) {
      prevDirtyRef.current = dirty;
      setDirty(dirty);
    }
  }, [values, initialValues, setDirty]);

  useEffect(() => {
    return () => {
      setDirty(false);
      prevDirtyRef.current = false;
    };
  }, [setDirty]);

  return null;
};

export default DsokCustomerDetailDirtySync;
